import { atom, useRecoilValue, useSetRecoilState } from 'recoil';
import { AuthState } from '@okta/okta-auth-js';
import { AuthConfig, externalAuth } from 'config/oktaConfig';

const oktaTokenStorage = localStorage.getItem('okta-token-storage');
const oktaConfig = oktaTokenStorage ? JSON.parse(oktaTokenStorage) : null;

let accessToken: string | undefined;

export const getAuthToken = () => accessToken;
export const setAuthToken = (token?: string) => accessToken = token;

export const authConfig = atom<AuthConfig>({
    key: 'authConfig',
    default: oktaConfig?.idToken ?? externalAuth
});

export const authState = atom<AuthState | null>({
    key: 'authState',
    default: null
});

export const isAuthenticated = atom<boolean>({
    key: 'isAuthenticated',
    default: false
});

export const useAuthConfig = () => useRecoilValue(authConfig);
export const useAuthState = () => useRecoilValue(authState);
export const useIsAuthenticated = () => useRecoilValue(isAuthenticated);
export const useSetAuthConfig = () => useSetRecoilState(authConfig); 
export const useSetAuthState = () => useSetRecoilState(authState);
export const useSetIsAuthenticated = () => useSetRecoilState(isAuthenticated);